import React from 'react'
import { Icon, ClockIcon } from 'labguard-cdk'
import LowLimitIcon from './LowLimitIcon'

const DelayedLowLimitIcon = props => (
  <span className="fa-layers">
    <Icon icon={LowLimitIcon} {...props} />
    <Icon icon={ClockIcon} transform="shrink-8 up-5 right-5" {...props} />
  </span>
)

export default DelayedLowLimitIcon
